import { Tag } from "antd";

const SettlementStatusTag: React.FC<{ status: string }> = ({ status }) => {
    return (
        status === "INCOMPLETED" ? <Tag color="error">미정산</Tag> : <Tag color="success">정산완료</Tag>
    );
};

export default SettlementStatusTag;